const DEPTH_WIDTH = 16;

export function getInsertionCursorPaddingLeft(depth: number) {
  return `${DEPTH_WIDTH * depth - depth}px`;
}

export function getDeltaOffsetDepth(deltaX: number) {
  return Math.floor(deltaX / DEPTH_WIDTH);
}
